module.exports = __webpack_public_path__ + "img/done.9d61a62e.svg";